import { type FC, useCallback, useState } from 'react';
import { Popup } from '../../components/Popup';
import shopifyIntegrationIcon from 'src/redesign/assets/integrations/shopify-integration-icon.svg';
import ecwidIntegrationIcon from 'src/redesign/assets/integrations/ecwid-integration-icon.svg';

import wordpressIntegrationIcon from 'src/redesign/assets/integrations/wordpress-integration-icon.svg';

import wixIntegrationIcon from 'src/redesign/assets/integrations/wix-integrations-icon.svg';

import { classes } from './NewSitePopup.st.css';
import c from 'clsx';
import { useAppDispatch } from '../../../hooks';
import { createNewSite } from '../../../features/site-slice';
import { InputText } from 'primereact/inputtext';
import { Button } from 'wix-style-react';
import { Divider } from 'primereact/divider';
import { API_URL } from 'src/utils/transport';

type NewSitePopupProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const NewSitePopup: FC<NewSitePopupProps> = ({ isOpen, onClose }) => {
  const [name, setName] = useState('');
  const [url, setUrl] = useState('');
  const dispatch = useAppDispatch();

  const handleClick = useCallback(async () => {
    await dispatch(createNewSite({ name, url, type: 'standalone' }));
    onClose();
    window.location.reload();
  }, [name, url, onClose, dispatch]);

  return (
    <Popup
      dataHook="new-site-modal"
      width={644}
      isOpen={isOpen}
      onCloseButtonClick={onClose}
      title={<span className={classes.modalHeader}>Create or Connect Your Site</span>}
    >
      <div className={classes.content}>
        <div className={classes.newSiteSection}>
          <div className={classes.inputWrapper}>
            <label htmlFor="site-name-input" className={classes.inputLabel}>
              Site Name
            </label>
            <InputText
              className={classes.input}
              id="site-name-input"
              placeholder="My Site"
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className={classes.inputWrapper}>
            <label htmlFor="site-url-input" className={classes.inputLabel}>
              Site URL
            </label>
            <InputText
              className={classes.input}
              id="site-url-input"
              placeholder="https://example.com"
              onChange={(e) => setUrl(e.target.value)}
            />
          </div>

          <div className={classes.buttonWrapper}>
            <Button className={classes.button} onClick={handleClick}>
              Create
            </Button>
          </div>
        </div>
        <Divider className={classes.integrationsDivider} layout="horizontal" align="center">
          <span className={classes.integrationsDividerText}>or</span>
        </Divider>
        <span className={classes.integrationsTitle}>Connect Your Site Using Our Integrations</span>
        <div className={classes.integrations}>
          <a
            className={c(classes.integrationLink, classes.shopify)}
            href={`${API_URL}/shopify/auth`}
          >
            <img src={shopifyIntegrationIcon} alt="shopify" width={30} />
            <span>Connect Shopify</span>
          </a>
          <a
            className={c(classes.integrationLink, classes.ecwid)}
            href="https://www.ecwid.com/apps/featured/ticket-spot"
          >
            <img src={ecwidIntegrationIcon} alt="ecwid" width={30} />
            <span>Connect Ecwid</span>
          </a>
          <div className={c(classes.integrationLink, classes.wordpress)}>
            <img src={wordpressIntegrationIcon} alt="wordpress" width={30} />
            <span>Connect Wordpress</span>
          </div>
          <a
            className={c(classes.integrationLink, classes.wix)}
            href="https://www.wix.com/app-market/event-viewer"
            target="_blank"
            rel="noreferrer"
          >
            <img src={wixIntegrationIcon} alt="wix" width={30} />
            <span>Connect WiX</span>
          </a>
        </div>
      </div>
    </Popup>
  );
};
